import React, {useCallback, useContext, useEffect, useRef} from 'react';
import {useLocation} from 'react-router-dom';

import {BroadcastContext} from 'src/contexts/brodcast-context';
import {AUTH_CALLBACK_EVENTS} from
    'src/modules/profile/account/tabs/license-and-features/crm-tab/constants';

import Loading from '@pb/kit-component-loading';

import {useSaveHubspotAuth} from './useSaveHubspotAuth';

export const HubspotOauthCallback = () => {
    const {search} = useLocation();
    const {sendMessage} = useContext(BroadcastContext);
    const isProcessed = useRef(false);

    const broadcastAndClose = useCallback(
        (result: {success: boolean, error?: string}) => {
            sendMessage(JSON.stringify({
                [AUTH_CALLBACK_EVENTS.HUBSPOT]: result,
            }));
            window.close();
        },
        [sendMessage],
    );

    const {
        isLoading: isSaveBusy,
        action: saveHubspotAuthCredentials,
    } = useSaveHubspotAuth({
        onSuccess: () => broadcastAndClose({success: true}),
        onFailure: error => broadcastAndClose({success: false, error}),
    });

    useEffect(() => {
        if (isProcessed.current) {
            return;
        }

        const params = new URLSearchParams(search.slice(1));
        const authorizationCode = params.get('code');
        const accountId = params.get('state');
        const error = params.get('error');

        if (error) {
            isProcessed.current = true;
            broadcastAndClose({success: false, error: 'Access Denied'});
        } else if (authorizationCode && accountId) {
            isProcessed.current = true;
            saveHubspotAuthCredentials({
                authorizationCode,
                accountId: Number(accountId),
            });
        }
    }, [search, saveHubspotAuthCredentials, broadcastAndClose]);

    return isSaveBusy ? <Loading fast={true}/> : null;
};
